<template>
  <div class="dashboard">
    <component-navbar />
    <div class="container">
      <div class="card-columns">
        <div class="card-body">
          <h5 class="card-title">
            PUBLIC
          </h5>
          <p class="card-text">
            This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import componentNavbar from '@/components/Navbar'

export default {
  components: {
    componentNavbar
  },
  data () {
    return {
      stories: []
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
@import url('https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css');
</style>
